import { collection, doc, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import useAuth from '../Auth/useAuth';
import { db } from '../firebase';

const ProfilePage = () => {
    const {user}=useAuth();
    const [studentProfile,setStudentProfile] = useState([]);

    // useEffect(() => {
    //    onSnapshot(doc(db, "studentLists",user.uid ), (doc) => {
    //     let studentArray = [];
    //         studentArray.push( {id:doc.id,...doc.data()});
    //         setStudentProfile(studentArray);
    //     });
    //     },[])

   useEffect(()=>{
    const q = query(collection(db, "admissionStudentList"), where("emailId", "==",user.email));
     const unsubscribe = onSnapshot(q, (querySnapshot) => {
    let studentArray = [];
    querySnapshot.forEach((doc) => {
    studentArray.push( {id:doc.id,...doc.data()});
  });
  setStudentProfile(studentArray);
   });

   },[])

  return (
    <div className="bg-slate-100">
      <h1 className="text-left ml-6 pt-3 text-2xl font-semibold">
        Student Profile
      </h1>
     {studentProfile?.map((item, index) => (
      <div className="container" key={index}>
          <div className="p-4 ">
            <div className="bg-white grid grid-cols-2  ml-5 mr-5">
              <div className=" bg-white text-black text-lg font-bold "></div>
            </div>
           
            <div className="grid grid-cols-2  pl-5 pr-5 ">
              <div className="  text-black text-lg font-bold text-center pt-10  ">
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Full Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                    {item.fullName}
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6 ">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Father's Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.fathersName}
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        D.O.B
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.dateOfBirth}
                    </div>
                  </div>
                </div>

                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Category
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.category}
                    </div>
                  </div>
                </div>
              </div>
              <div className=" text-black text-lg font-bold text-center pt-10  pl-10 ">
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Student Code
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.studentIdNumber}
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Mother's Name
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.mothersName}
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Gender
                      </label>
                    </div>
                    <div className="md:w-2/5">
                     {item.gender}
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm">
                  <div className="md:flex md:items-center mb-6">
                    <div className="md:w-2/5">
                      <label
                        className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                        htmlFor="inline-full-name"
                      >
                        Contact No.
                      </label>
                    </div>
                    <div className="md:w-2/5">
                    {item.phoneNumber}
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Permanent Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.permanentAddressLine}
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Area/Road/Locality:
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.permanentAreaLocality}
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.permanentApartmentHouse}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                   {item.permanentZip}
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                   {item.permanentCity}
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                <div className="mb-4 md:w-1/3">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/3">
                    {item.permanentState}
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                  {item.permanentCountry}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Correspondence Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.correspondenceAddressLine}
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Area/Locality:
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.correspondenceAreaLocality}
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                 {item.correspondenceApartment}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                   {item.correspondenceZip}
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                   {item.correspondenceCity}
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    {item.correspondenceState}
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                {item.correspondenceCountry}
                </div>
              </div>
            </div>
          </div>
            </div>
          </div>      
      </div>
     ))}
    </div>
  )
}

export default ProfilePage